import { TableBody, TableCell, TableRow } from "@mui/material";
import {
  useCollapseTableFields,
  useTableLocation,
} from "../../../../../utils/helpers/dynamicTableField";

export const CollapseTableBodyComp = ({
  data,
  index,
}: {
  data: any;
  index: number;
}) => {
  const dynamicFields = useCollapseTableFields(useTableLocation());
  const parentIndex = dynamicFields[index].parentKey ?? null;
  const childIndex = dynamicFields[index].childKey ?? null;

  if (childIndex === null) {
    const parentData = data ? data[parentIndex] : null;

    // Handle case where parentData is null (e.g. valid species field is null)
    if (!parentData) {
      return (
        <TableBody>
          <TableRow>
            <TableCell colSpan={dynamicFields[index].fields.length}>
              No records found
            </TableCell>
          </TableRow>
        </TableBody>
      );
    }

    // Handle case where parentIndex points to a connection/list directly (like species in some contexts)
    // but without a childIndex specified in config.
    // However, based on schema, if it's a list we usually expect childIndex.
    // If species is a list (SpeciesConnection or List[Species]), we need to iterate.
    // Based on SWAPI GraphQL, "species" on Person is "Species" object (single) OR connection?
    // Let's check type. If it is an array, map it. If object, show single row.

    if (Array.isArray(parentData)) {
      return (
        <TableBody>
          {parentData.map((item: any, i: number) => (
            <TableRow key={i}>
              {dynamicFields[index].fields.map((field: any) => (
                <TableCell key={field.key} component="th" scope="row">
                  {item[field.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      );
    }

    return (
      <TableBody>
        <TableRow>
          {dynamicFields[index].fields.map((field: any) => (
            <TableCell key={field.key} component="th" scope="row">
              {parentData[field.key] ?? "No data"}
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    );
  }

  return (
    <TableBody>
      {data[parentIndex]?.[childIndex]?.map((key: any, i: number) => (
        <TableRow key={i}>
          {dynamicFields[index].fields.map((field: any) => (
            <TableCell key={field.key} component="th" scope="row">
              {key[field.key]}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};
